














































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ApiService } from '@/services/ApiService';
import { BestFriendOpenOrderApi } from '@eurogast/hub-client-typescript';
import { ConfigService } from '@/services/ConfigService';
import { BooleanService } from '@/services/util/BooleanService';

@Component
export default class OrderListsDropdown extends Vue {

  get showBestFriendMenu(): boolean {
    return BooleanService.fromString(this.localShowBestFriendMenu);
  }

  @Prop({required: false, default: 'false'})
  public localShowBestFriendMenu: string;

  private isLoggedIn: boolean = ConfigService.isLoggedIn();
  private bfApi = ApiService.wrap(BestFriendOpenOrderApi);
  private bfOrderCount = 0;

  public mounted() {
    if (this.isLoggedIn && this.showBestFriendMenu) {
      this.bfApi.getAllBestFriendOrders(ConfigService.getTenant(), ConfigService.currentCustomerId)
        .then((result) => this.bfOrderCount = result.length)
        .catch(ApiService.defaultErrorHandler);
    }
  }
}
